// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.modal-container {
  padding: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media (max-width: 768px) {
  .modal-container {
    padding: 15px;
  }
}
@media (max-width: 480px) {
  .modal-container {
    padding: 10px;
  }
}

.modal-header {
  margin-bottom: 20px;
}
.modal-header .modal-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
@media (max-width: 768px) {
  .modal-header .modal-title {
    font-size: 20px;
  }
}
@media (max-width: 480px) {
  .modal-header .modal-title {
    font-size: 18px;
  }
}

.modal-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.search-section {
  margin-bottom: 20px;
}
@media (max-width: 768px) {
  .search-section {
    margin-bottom: 15px;
  }
}

.search-input-container {
  position: relative;
  width: 100%;
}
.search-input-container .search-input {
  width: 100%;
  height: 40px;
  padding: 10px 15px 10px 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}
.search-input-container .search-input:focus {
  border-color: #0066b2;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}
@media (max-width: 480px) {
  .search-input-container .search-input {
    height: 36px;
    padding: 8px 12px 8px 36px;
    font-size: 13px;
  }
}
.search-input-container .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
}
@media (max-width: 480px) {
  .search-input-container .search-icon {
    left: 10px;
  }
}

.loading-container {
  height: 4px;
  margin-bottom: 10px;
}
.loading-container mat-progress-bar {
  height: 4px;
}

.table-container {
  flex: 1;
  overflow: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 20px;
  min-height: 0;
}
@media (max-width: 768px) {
  .table-container {
    border-radius: 0;
    margin: 0 -15px 15px -15px;
  }
}
@media (max-width: 480px) {
  .table-container {
    margin: 0 -10px 10px -10px;
  }
}

.results-table {
  width: 100%;
  background: white;
  table-layout: fixed;
}
@media (max-width: 768px) {
  .results-table {
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .results-table {
    font-size: 12px;
  }
}

.checkbox-column {
  width: 10%;
  min-width: 60px;
  max-width: 80px;
  text-align: center;
}
@media (max-width: 480px) {
  .checkbox-column {
    min-width: 50px;
    max-width: 60px;
  }
}

.code-column {
  width: 20%;
  min-width: 120px;
  max-width: 200px;
  font-family: monospace;
}
.code-column .note-code {
  font-weight: 600;
  color: #333;
  font-size: 13px;
}
@media (max-width: 768px) {
  .code-column {
    min-width: 100px;
    max-width: 150px;
  }
  .code-column .note-code {
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .code-column {
    min-width: 80px;
    max-width: 120px;
  }
  .code-column .note-code {
    font-size: 11px;
    line-height: 1.2;
  }
}

.description-column {
  width: 70%;
  min-width: 250px;
}
.description-column .note-description {
  display: block;
  line-height: 1.4;
  color: #555;
  font-size: 14px;
  padding: 4px 0;
  word-wrap: break-word;
}
.description-column .note-category {
  font-size: 0.8em;
  color: #888;
  font-style: italic;
  margin-top: 4px;
}
@media (max-width: 768px) {
  .description-column {
    min-width: 200px;
  }
  .description-column .note-description {
    font-size: 13px;
    line-height: 1.3;
  }
  .description-column .note-category {
    font-size: 0.7em;
  }
}
@media (max-width: 480px) {
  .description-column {
    min-width: 150px;
  }
  .description-column .note-description {
    font-size: 12px;
    line-height: 1.2;
    word-break: break-word;
  }
  .description-column .note-category {
    font-size: 0.7em;
  }
}

.table-row:hover {
  background-color: #f5f5f5;
}
.table-row:nth-child(even) {
  background-color: #fafafa;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
@media (max-width: 768px) {
  .pagination-container {
    margin: 15px 0;
  }
}
.pagination-container .custom-paginator {
  background: transparent;
}

.selection-summary {
  padding: 15px;
  background-color: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 4px;
  margin-bottom: 20px;
}
@media (max-width: 768px) {
  .selection-summary {
    padding: 12px;
    margin-bottom: 15px;
  }
}
.selection-summary .selection-count {
  display: flex;
  align-items: center;
  gap: 8px;
}
.selection-summary .selection-count .count-badge {
  background-color: #0066b2;
  color: white;
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
}
.selection-summary .selection-count .count-text {
  font-size: 14px;
  color: #333;
}
@media (max-width: 480px) {
  .selection-summary .selection-count .count-text {
    font-size: 13px;
  }
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  margin-top: auto;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .modal-actions {
    padding-top: 15px;
  }
}
@media (max-width: 480px) {
  .modal-actions {
    flex-direction: column;
    gap: 8px;
  }
}
.modal-actions .btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  min-width: 80px;
  transition: all 0.2s ease;
}
.modal-actions .btn.btn-secondary {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}
.modal-actions .btn.btn-secondary:hover {
  background-color: #e0e0e0;
}
.modal-actions .btn.btn-primary {
  background-color: #0066b2;
  color: white;
}
.modal-actions .btn.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}
.modal-actions .btn.btn-primary:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .modal-actions .btn {
    padding: 8px 16px;
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .modal-actions .btn {
    padding: 10px;
    font-size: 14px;
    min-width: 100%;
  }
}

::ng-deep .mat-mdc-checkbox {
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #0066b2;
  --mat-checkbox-selected-hover-icon-color: #0066b2;
  --mat-checkbox-selected-icon-color: #0066b2;
  --mat-checkbox-selected-pressed-icon-color: #0066b2;
}
::ng-deep .mat-mdc-table {
  --mat-table-row-item-outline-width: 0;
  box-shadow: none;
}
::ng-deep .mat-mdc-header-cell {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #dee2e6;
}
@media (max-width: 480px) {
  ::ng-deep .mat-mdc-header-cell {
    font-size: 11px;
    padding: 8px 4px;
  }
}
::ng-deep .mat-mdc-header-cell.checkbox-column {
  text-align: center;
  padding: 12px 8px;
  width: 10%;
}
::ng-deep .mat-mdc-header-cell.code-column {
  padding: 12px 16px;
  width: 20%;
}
::ng-deep .mat-mdc-header-cell.description-column {
  padding: 12px 20px;
  width: 70%;
}
@media (max-width: 480px) {
  ::ng-deep .mat-mdc-cell {
    padding: 8px 4px;
  }
}
::ng-deep .mat-mdc-cell.checkbox-column {
  text-align: center;
  padding: 12px 8px;
  width: 10%;
}
::ng-deep .mat-mdc-cell.code-column {
  padding: 12px 16px;
  width: 20%;
}
::ng-deep .mat-mdc-cell.description-column {
  padding: 12px 20px;
  width: 70%;
}
::ng-deep .mat-paginator {
  border-top: 1px solid #e0e0e0;
}
@media (max-width: 480px) {
  ::ng-deep .mat-paginator .mat-paginator-page-size-select {
    width: 40px;
  }
  ::ng-deep .mat-paginator .mat-paginator-range-label {
    font-size: 11px;
    margin: 0 4px;
  }
}
@media (max-width: 768px) {
  ::ng-deep .mat-mdc-dialog-container {
    padding: 0;
  }
}

.readonly-note {
  color: #666;
  font-style: italic;
}

.readonly-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 6px;
  background-color: #f0f0f0;
  color: #666;
  font-size: 11px;
  border-radius: 12px;
  font-style: normal;
}

mat-checkbox[ng-reflect-disabled=true] {
  opacity: 0.6;
}
mat-checkbox[ng-reflect-disabled=true] .mat-checkbox-layout {
  cursor: not-allowed;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
